// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZbdL","content":"styles_content__ylsLZ","tableWrap":"styles_tableWrap__3-3Bh"};